import { appInfo } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10 bg-background-950 rounded-2xl overflow-hidden">
          <div className="w-full lg:w-1/2 p-6 md:p-10 lg:p-12">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-background-50 mb-3">
              {appInfo.title}
            </h2>
            <p className="text-sm md:text-base text-background-200/80 leading-relaxed mb-5">
              {appInfo.description}
            </p>
            <div className="flex flex-wrap gap-3">
              <div className="flex items-center gap-2 px-4 py-2 bg-background-50/10 border border-background-300/20 rounded-lg text-sm text-background-200 whitespace-nowrap">
                <i className="ri-smartphone-line"></i>
                <span>手机浏览器即开即看</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-background-50/10 border border-background-300/20 rounded-lg text-sm text-background-200 whitespace-nowrap">
                <i className="ri-tablet-line"></i>
                <span>平板大屏沉浸体验</span>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20and%20tablet%20displaying%20cinematic%20movie%20interface%20with%20film%20posters%2C%20dark%20elegant%20UI%20design%2C%20warm%20ambient%20lighting%2C%20minimalist%20desk%20setup%2C%20soft%20golden%20highlights%2C%20no%20text%20visible%20on%20screens%2C%20premium%20device%20mockup%2C%20professional%20product%20photography%2C%20rich%20burgundy%20accents%2C%20cinematic%20color%20grading&width=900&height=600&seq=jiubo-app-visual&orientation=landscape"
              alt="久播影院移动端观影体验"
              className="w-full h-full object-cover min-h-[250px] md:min-h-[300px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}